import {BrowserModule} from '@angular/platform-browser';
import {ErrorHandler, NgModule} from '@angular/core';
import {IonicApp, IonicErrorHandler, IonicModule} from 'ionic-angular';
import {SplashScreen} from '@ionic-native/splash-screen';
import {StatusBar} from '@ionic-native/status-bar';
import {HttpClientModule, HttpClient} from '@angular/common/http';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {MyApp} from './app.component';
import {HomePage} from '../pages/home/home';
import {B2dProvider} from '../providers/b2d/b2d';
import {ConfigService} from "./config.service";
import {VariablesGlobales} from "./variablesGlobales";
import {AppRoutingModule} from "./app-routing.module";
import {RoundProgressModule} from 'angular-svg-round-progressbar';
import {ModalPageModule} from "../pages/modal/modal.module";

export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
    declarations: [
        MyApp,
        HomePage
    ],
    imports: [
        BrowserModule,
        HttpClientModule,
        IonicModule.forRoot(MyApp),
        AppRoutingModule,
        RoundProgressModule,
        ModalPageModule
    ],
    bootstrap: [IonicApp],
    entryComponents: [
        MyApp,
        HomePage
        //  ScreenTestAonPage
    ],
    providers: [
        StatusBar,
        SplashScreen,
        {provide: ErrorHandler, useClass: IonicErrorHandler},
        B2dProvider,
        ConfigService,
        VariablesGlobales
    ]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts